import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface MascotPanelProps {
  title?: string;
  message: string;
  detailedInfo?: string;
}
export function MascotPanel({
  title = 'Norden zegt:',
  message,
  detailedInfo
}: MascotPanelProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex items-start gap-3" data-id="element-588">
      <div className="flex-shrink-0" data-id="element-589">
        <div className="w-12 h-12 rounded-full border-2 border-white shadow-sm overflow-hidden bg-blue-50" data-id="element-590">
          <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden Mascot" className="w-full h-full object-cover" data-id="element-591" />
        </div>
      </div>

      <div className="flex-1 bg-white rounded-2xl p-4 shadow-sm border border-gray-100" data-id="element-592">
        <p className="text-xs font-bold text-[#007AFF] mb-1" data-id="element-593">{title}</p>
        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-594">{message}</p>

        {detailedInfo && <div className="mt-2" data-id="element-595">
            <button onClick={() => setIsExpanded(!isExpanded)} className="text-xs font-semibold text-[#007AFF] hover:text-[#005FCC] flex items-center transition-colors" data-id="element-596">
              {isExpanded ? 'Minder info' : 'Meer info'}
              {isExpanded ? <ChevronUpIcon className="w-3 h-3 ml-1" data-id="element-597" /> : <ChevronDownIcon className="w-3 h-3 ml-1" data-id="element-598" />}
            </button>
            <AnimatePresence data-id="element-599">
              {isExpanded && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="overflow-hidden" data-id="element-600">
                  <p className="text-gray-500 text-sm leading-relaxed mt-2 pt-2 border-t border-gray-100" data-id="element-601">
                    {detailedInfo}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>}
      </div>
    </motion.div>;
}